import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faSort,
  faSortUp,
  faSortDown,
  type IconDefinition,
} from '@fortawesome/free-solid-svg-icons'

type usedIconNames = 'faSort' | 'faSortUp' | 'faSortDown'
const usedIconMapping: { [key in usedIconNames]: IconDefinition } = {
  faSort,
  faSortUp,
  faSortDown,
}

interface FaIconProps {
  iconName: usedIconNames
}

export function FaIcon({ iconName }: FaIconProps) {
  return <FontAwesomeIcon icon={usedIconMapping[iconName]} />
}
